import type { Capability } from "@love-cpmd/core";
import { CalendarCheck, CalendarDays, ChartColumnBig, History, LayoutDashboard, NotebookText, Settings2, type LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  /** Shorter label for the bottom nav. */
  short?: string;
  icon: LucideIcon;
  /** Shown as a bottom-nav tab on mobile. */
  tab?: boolean;
  cap?: Capability;
}

/** Same names and order on every screen size (plan: "Model navigasi"). */
export const MAIN_NAV: NavItem[] = [
  { to: "/dashboard", label: "Dashboard", short: "Home", icon: LayoutDashboard, tab: true },
  { to: "/schedule", label: "Schedule", icon: CalendarDays, tab: true },
  { to: "/summary", label: "Summary", icon: NotebookText, tab: true },
  { to: "/insights", label: "Topic Insights", short: "Insights", icon: ChartColumnBig, tab: true },
  { to: "/activity", label: "Activity Log", icon: History, cap: "activity.view" },
  { to: "/my-schedule", label: "My Schedule", icon: CalendarCheck, cap: "mySchedule.view" },
];

export const ADMIN_NAV: NavItem = { to: "/admin", label: "Manage System", icon: Settings2, cap: "admin.access" };
